export const SET_DUPLICATING_SHIPMENT = 'Rollo/SET_DUPLICATING_SHIPMENT';

export const setDuplicatingShipment = (payload: object | null) => {
  return {
    type: SET_DUPLICATING_SHIPMENT,
    payload,
  };
};
